
import { Component, Vue, Prop } from 'vue-property-decorator'
import { handleFill, moneyFormat } from '@/utils/util';

@Component
export class Cashier extends Vue {
  @Prop({ default: () => { } }) accountData: any
  @Prop({ default: () => { } }) billData: any
  handleFill = handleFill
  moneyFormat = moneyFormat
  payWayList = ['现金', '储值卡', '微信', '支付宝', '二维码', '交易合计'] // 0现金,1储值卡,2微信,3支付宝,4二维码,5交易合计
}
export default Cashier
